import serviceClient from '../../service-client/service-client';

const restoreSiteBackup = (backupId) => () => {
  const apiClient = serviceClient.get();
  return apiClient.restoreSiteBackup(backupId);
};

export default restoreSiteBackup;
